import { wOrgIdMiddleware } from "../utils/commonUtils";
import { OK } from "../utils/constant";
import http from "./http";

const StateFormConfifService = {
  stateFormList: wOrgIdMiddleware(async (url, query = {}) => {
    const queryString = new URLSearchParams(query).toString();

    try {
      const response = await http.POST(`${url}stateFormList?${queryString}`);
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }),

  columnList: wOrgIdMiddleware(async (url, data) => {
    console.log(data, "data");

    try {
      const response = await http.POST(`${url}columnList/visits`, data);
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  },true),

  saveForm: wOrgIdMiddleware(
    async (
      url,
      data,
      headers = {
        "Content-Type": "multipart/form-data",
      }
    ) => {
      try {
        const response = await http.POST(`${url}saveForm/`, data, headers);

        if ((response.code === 200 || response.code === 201) && response.data) {
          return response;
        } else {
          return response;
        }
      } catch (error) {
        console.error("Error fetching user:", error);
        if (error.status) {
          const resData = error.data;
          if (resData.code && resData.data) {
            return resData;
          }
        }
      }
    },true
  ),

  deleteForm: wOrgIdMiddleware(async (url, form_id) => {
    console.log("formid",form_id);
    try {
      const response = await http.DELETE(`${url}deleteForm/${form_id}`);
      return response;
    } catch (error) {
      console.error("Delete error", error);
      throw error;
    }
  }),

  editForm: wOrgIdMiddleware(async (url, form_id,) => {
    console.log("formid",form_id);
    try {
      const response = await http.GET(`${url}editForm/${form_id}`);
      return response;
    } catch (error) {
      console.error("Edit error", error);
      throw error;
    }
  }),
  updateForm: wOrgIdMiddleware(async (url, form_id,data,headers = {
    "Content-Type": "multipart/form-data",
  }) => {
    console.log("formid",form_id);
    try {
      const response = await http.POST(`${url}updateForm/${form_id}`, data, headers);
      return response;
    } catch (error) {
      console.error("Edit error", error);
      throw error;
    }
  }),
  downloadForm: wOrgIdMiddleware(async (url, form_id,) => {
    // console.log("formid",form_id);
    try {
      const response = await http.GET(`${url}getFile/${form_id}`);
      return response;
    } catch (error) {
      console.error("Edit error", error);
      throw error;
    }
  }),

  getFormByState: wOrgIdMiddleware(async (url, visit_id,) => {
    // console.log("formid",form_id);
    try {
      const response = await http.GET(`${url}getFormByState/${visit_id}`);
      return response;
    } catch (error) {
      console.error("Edit error", error);
      throw error;
    }
  }),

  downloadFilledForm:(async (form_id,visit_id) => {
    // console.log("formid",form_id);
    try {
      const response = await http.GET(`download-states-form/${form_id}/${visit_id}`);
      return response;
    } catch (error) {
      console.error("Edit error", error);
      throw error;
    }
  }),
};
export default StateFormConfifService;
